import React from 'react';
import { css, SerializedStyles } from '@emotion/react';

interface SpeechBubbleProps {
  children: React.ReactNode;
  trianglePosition?: 'top' | 'bottom';
  triangleHorizontalPosition?: 'left' | 'right';
  textAlign?: 'center' | 'left' | 'right';
}

const SpeechBubble: React.FC<SpeechBubbleProps> = ({
  children,
  trianglePosition = 'top',
  triangleHorizontalPosition = 'right',
  textAlign = 'center',
}) => {
  const speechBubbleStyle: SerializedStyles = css`
    position: relative;
    background: white;
    padding: 8px;
    font-size: 12px;
    text-align: ${textAlign};
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    color: #000000;

    &::after {
      content: '';
      position: absolute;
      ${triangleHorizontalPosition}: 20px;
      ${trianglePosition === 'top' ? 'top: -9px;' : 'bottom: -9px;'}
      width: 13px;
      height: 9px;
      background: white;
      clip-path: ${trianglePosition === 'top'
        ? 'polygon(50% 0%, 0% 100%, 100% 100%)'
        : 'polygon(50% 100%, 0% 0%, 100% 0%)'};
    }
  `;
  return <div css={speechBubbleStyle}>{children}</div>;
};

const StoryGameMyImageDefaultBubble: React.FC<SpeechBubbleProps> = ({
  children,
  trianglePosition,
  triangleHorizontalPosition,
  textAlign,
}) => {
  return (
    <SpeechBubble
      trianglePosition={trianglePosition}
      triangleHorizontalPosition={triangleHorizontalPosition}
      textAlign={textAlign}
    >
      {children}
    </SpeechBubble>
  );
};

export default StoryGameMyImageDefaultBubble;
